<ion-segment
  mode="ios"
  [value]="selected"
  [scrollable]="true"
  class="subcategory-segment"
  [ngClass]="{ 'scroll-segment': isDesktop }"
  [@listAnimation]="agrupadores.length"
>
  <ng-container *ngFor="let agrupador of agrupadores; trackBy: trackByGroupers">
    <ion-segment-button
      layout="label-hide"
      [value]="agrupador"
      class="subcategory-button"
      (click)="onAgrupadorClick(agrupador.ID_Agrupador_GETM)"
    >
      <ion-thumbnail class="subcategory-image-container">
        <ion-img
          [src]="agrupador.Imagen"
          [class.inactive]="
            activeAgrupador && agrupador.ID_Agrupador_GETM !== activeAgrupador
          "
        ></ion-img>
      </ion-thumbnail>
    </ion-segment-button>
  </ng-container>
</ion-segment>
